<template>
<v-container>
  <v-layout>
    <v-flex>{{ message }}</v-flex>
  </v-layout>
</v-container>
</template>

<script>
import axios from 'axios'
import config from '../../../configApi'
const apiUrl = config.apiUrl

export default {
  data () {
    return {
      message: 'checking for verification...'
    }
  },
  methods: {
    checkVerification (token) {
      axios.get(apiUrl + '/user/verify/' + token).then(res => {
        let token = res.data.data
        this.message = res.data.message
        setTimeout(() => {
          if (token) {
            this.$router.push('/password/reset/' + token)
            return
          }
          this.$router.push('/login')
        }, 2000)
      }).catch(err => {
        console.log(err)
        this.message = err.response.data.message
      })
    }
  },
  mounted () {
    this.checkVerification(this.$route.params.token)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/verify/index.vue